const DAY_MS = 24 * 60 * 60 * 1000;

function parseDateOnly(value?: string | Date | null): Date | null {
  if (!value) return null;

  if (typeof value === 'string') {
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    }
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;

  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function calculateRemainingDays(endDate?: string | Date | null): number {
  const end = parseDateOnly(endDate);
  if (!end) return 0;

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  return Math.max(0, Math.floor((end.getTime() - today.getTime()) / DAY_MS) + 1);
}

export function calculateTotalDays(startDate?: string | Date | null, endDate?: string | Date | null): number {
  const start = parseDateOnly(startDate);
  const end = parseDateOnly(endDate);

  if (!start || !end || end.getTime() < start.getTime()) return 0;

  return Math.floor((end.getTime() - start.getTime()) / DAY_MS) + 1;
}

export function formatDateLabel(value?: string | Date | null, locale?: string): string | null {
  const date = parseDateOnly(value);
  if (!date) return null;
  return date.toLocaleDateString(locale);
}